export { default as TancadasTurno } from "./TancadasTurno";
